import styled from 'styled-components';

export const FeeNoteContainer = styled.div`
  margin-top: 50px;
  .MuiTabs-flexContainer {
    padding: 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .MuiTab-root {
  }
  .fee-notes-container {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }
  .invisible {
    visibility: hidden;
  }
  .button-space {
    margin-right: 5px;
  }
  .status-container {
    display: 'flex',
    text-align: 'center',
    vertical-align: 'middle',
    .message {
      vertical-align: 'middle';
    }
  }
  .amount {
    padding-right: 5%;
  }
  .searchBar {
    padding: 12px;
    left: 230px;
  }
`;

export const ContainerInDrawer = styled.div`
  .subContainer {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  .text {
    font-size: 13px;
    color: #374065;
    letter-spacing: 0px;
    font-weight: medium;
    font-family: Roboto;
  }
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
  .error {
    margin-top: -5px;
    color: red;
    text-align: center;
  }
  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;

export const FormContainer = styled.div`
  .align-right {
    text-align: right;
  }
  .button-left-space {
    margin-left: 15px;
  }
  .max-content {
    width: max-content !important;
  }
  .subtitle {
    margin-top: 10px;
    margin-bottom: 15px;
    font-weight: bolder;
    font-size: 16px;
  }
  .fee-note-form {
    button {
      width: 100%;
    }
    .upload-doc-title {
      font-weight: bolder;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
`;

export const CollapseContainer = styled.div`
  .title {
    color: rgba(9, 122, 194, 1);
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    -webkit-letter-spacing: 0px;
    -moz-letter-spacing: 0px;
    -ms-letter-spacing: 0px;
    letter-spacing: 0px;
    color: #0075c9;
    text-transform: uppercase;
    opacity: 1;
    margin-bottom: 5px;
  }
  .pj-container {
    padding: 10px;
  }
  .cheque-container {
    padding: 10px;
  }
  .doc-container {
    padding: 0px;
    margin-top: 15px;
  }
  .cheque-fields-box {
    box-shadow: 0px 1px 3px #0000001f;
    padding: 10px;
    border-radius: 4px;
    opacity: 1;
  }
  .title-check-fields {
    font-size: 13px;
    color: #999999;
  }
`;
